import {useEffect} from 'react'
import * as api from '@api'
import {useQuery, useQueryClient} from '@/hooks/useApi'
import {transformFacilityProcesses} from '@utils'

export default function useFacilityProcessesList() {
  const queryClient = useQueryClient()

  useEffect(() => {
    const prefetchData = async () => {
      //Only prefetch if data is not already in the cache
      if (!queryClient.getQueryData('getFacilityProcesses')) {
        await queryClient.prefetchQuery('getFacilityProcesses', api.getFacilityProcesses)
      }
    }
    prefetchData()
  }, [queryClient])

  const {data: queryData, isSuccess} = useQuery('getFacilityProcesses', api.getFacilityProcesses, {
    gcTime: 24 * 3600 * 1000,
    staleTime: 24 * 3600 * 1000,
    initialData: () => {
      return queryClient.getQueryData('getFacilityProcesses')
    },
    // Only run the query if data is not already in the cache
    enabled: !queryClient.getQueryData('getFacilityProcesses'),
  })

  const facilityProcessesList = isSuccess ? transformFacilityProcesses(queryData?.data?.facilities) : []

  return facilityProcessesList
}
